import * as React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { IconButton, Typography, Box } from "@mui/material";
import "@fontsource/titillium-web/700.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from '@react-three/drei';
import { Auth } from "../../components/Auth/auth";
import axios from "axios";
import { LOCALES } from "../../i18n";
import { importBaseActions } from "../../store/reducers/base";
import { useDispatch } from "react-redux";

export const RecuperaSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const email = state?.email || "email non disponibile";
  const baseActions = importBaseActions();

  // --- OTP state e logica ---
  const inputsRef = React.useRef([]);
  const [otpValues, setOtpValues] = React.useState(Array(6).fill(''));
  const [isError, setIsError] = React.useState(false);
  const [isCodeExpired, setIsCodeExpired] = React.useState(false);
  const [isPending, setIsPending] = React.useState(false);
  const [timeLeft, setTimeLeft] = React.useState(300); // 5 minuti

  // Countdown timer
  React.useEffect(() => {
    if (timeLeft <= 0) {
      setIsCodeExpired(true);
      return;
    }
    const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const formatted = `${Math.floor(timeLeft / 60).toString().padStart(2, '0')}:${(timeLeft % 60).toString().padStart(2, '0')}`;

  const handleChange = (e, index) => {
    const val = e.target.value;
    if (!/^\d?$/.test(val)) return; // solo numeri
    const newOtp = [...otpValues];
    newOtp[index] = val;
    setOtpValues(newOtp);
    if (val && index < 5) inputsRef.current[index + 1].focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };
  const manageOtp = async () => {
    // Se il codice è scaduto, resettiamo tutto
    if (isCodeExpired) {
      setOtpValues(Array(6).fill(''));
      setIsCodeExpired(false);
      setTimeLeft(300);
      setIsError(false);
      return;
    }

    const otp = otpValues.join('');
    setIsPending(true);
    setIsError(false);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login-otp`, {
        email: email,
        otp: otp,
      });
      if (response.data.success) {
        dispatch(baseActions.setUser(response.data.data));
        dispatch(baseActions.setLocale(LOCALES.ITALIAN));
        console.log("data",response.data.data)
        navigate('/new-password', { state: { disableBack: true } });
      } else {
        setIsError(true);
      }
    } catch (error) {
      console.error('Errore durante la verifica OTP:', error);
      setIsError(true);
    } finally {
      setIsPending(false);
    }
  };
  return (
    <Auth
      header={
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography fontWeight={700} variant="h3" component="div">
            Recupera password
          </Typography>
        </Grid>
      }
    >
      <Box sx={{ py: 5, px: 2, maxWidth: 500, mx: "auto" }}>
        <Typography fontWeight={400} variant="h5" component="div" sx={{ mb: 2, textAlign: "center" }}>
          Inserisci il codice OTP che abbiamo inviato al tuo indirizzo email {email}
        </Typography>

        {/* --- OTP Inputs --- */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mb: 2 }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <input
              key={i}
              ref={(el) => { inputsRef.current[i] = el; }}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={otpValues[i]}
              onChange={(e) => handleChange(e, i)}
              onKeyDown={(e) => handleKeyDown(e, i)}
              style={{
                width: 50,
                height: 50,
                textAlign: "center",
                fontSize: 20,
                border: `2px solid ${isError ? "red" : "#1976d2"}`,
                borderRadius: 4,
              }}
            />
          ))}
        </Box>

        {isError && !isCodeExpired && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            Codice non valido. Riprova.
          </Typography>
        )}

        {isCodeExpired && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            Codice scaduto. Riprova.
          </Typography>
        )}

        <Typography align="center" sx={{ mb: 1 }}>
          Il codice scadrà tra {formatted}
        </Typography>

        <Button
          onClick={manageOtp}
          fullWidth
          variant="contained"
          sx={{ mt: 2, py: 1.5, fontWeight: "bold", fontSize: 16 }}
        >
          {isCodeExpired ? 'Riprova' : isPending ? <Loader /> : 'Conferma codice'}
        </Button>
      </Box>
    </Auth>
  );
};
